import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tailsPrice'
})
export class TailsPricePipe implements PipeTransform {

  transform(value: number): string {
    let pr = value.toString().split('.');
    if (pr.length > 1) {
      if (pr[1].length === 1) {
        return pr[1] + '0';
      }
      return pr[1];
    } else {
      return '00';
    }
  }

}
